import { SimpleValidate } from './SimpleValidate'

class SimpleWizard {
    el: HTMLElement
    nextButtonEls: NodeListOf<HTMLButtonElement>
    prevButtonEls: NodeListOf<HTMLButtonElement>
    stepsEls: NodeListOf<HTMLElement>
    navEl: HTMLElement | null

    constructor(triggerElement: HTMLElement) {
        this.el = triggerElement

        this.nextButtonEls = this.el.querySelectorAll('[simple-wizard-next]')
        this.prevButtonEls = this.el.querySelectorAll('[simple-wizard-previous]')
        this.stepsEls = this.el.querySelectorAll('[simple-wizard-step]')
        this.navEl = document.querySelector('[simple-wizard-nav-items]');
        
        this.nextButtonEls?.forEach(trigger => {
            trigger.addEventListener('click', () => this.next())
        })

        this.prevButtonEls?.forEach(trigger => {
            trigger.addEventListener('click', () => this.previous())
        })

        this.el.querySelectorAll('[simple-wizard-one-required]').forEach(trigger => {
            trigger.addEventListener('click', (event) => {
                let item = event.target as HTMLElement
                if (item) {
                    let curNextBtn = item.closest('[simple-wizard-step]')?.querySelector('[simple-wizard-next]') as HTMLButtonElement
                    if (curNextBtn) {
                        curNextBtn.disabled = false
                        curNextBtn.classList.add('is-active')
                    }
                }
            })
        })

        this.el.querySelectorAll('[simple-wizard-goto-slide]').forEach(item => {
            item.addEventListener('click', (event) => {
                event.preventDefault()

                let goto = Number((event.target as HTMLElement).getAttribute('simple-wizard-goto-slide'))
                this.showStep(goto)
            })
        })
    }

    getCurrentStep() {
        for (let i = 0; i < this.stepsEls.length; i++) {
            if (this.stepsEls[i].matches('.is-active')) {
                return i
            }
        }

        return -1
    }

    showStep(stepToShow: number) {
        console.log("show step")
        for (let i = 0; i < this.stepsEls.length; i++) {
            this.stepsEls[i].classList.toggle('is-active', i == stepToShow)
        }

        // Validate fields
        let curStep = this.stepsEls[stepToShow]
        let curNext = curStep.querySelector<HTMLButtonElement>('[simple-wizard-next]')
        let flds = curStep.querySelectorAll('[simple-wizard-one-required]')

        if (curNext) {
            console.log("cur next")
            if (flds.length > 0) {
                let cntChecked = curStep.querySelectorAll('[simple-wizard-one-required]:checked')?.length ?? 0

                if (curNext) {
                    curNext.disabled = cntChecked == 0
                    curNext.classList.toggle('is-active', cntChecked > 0)
                }
            }
            else {
                curNext.disabled = false
                curNext.classList.add('is-active')
            }
        }

        // Scroll to top
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });

        // Update Nav
        this.updateNav(stepToShow);
    }

    updateNav(stepNumber: number) {
        const navItems = this.navEl?.querySelectorAll('li, div');
        
        navItems?.forEach((item, index) => {
            item.classList.remove('is-active');
            item.classList.toggle('is-done', index < stepNumber)
        });
        
        navItems?.[stepNumber].classList?.add('is-active');
    }

    next() {
        //el.preventDefault()
        let curStep = this.getCurrentStep()
        
        // Validate
        const frm = this.el.querySelector('form[simple-validate]') as HTMLFormElement

        if (frm) {
            let svf = SimpleValidate.getInstance(frm)

            if (svf.validate()) {
                this.showStep(curStep + 1)
            }
        }
        else {
            this.showStep(curStep + 1)
        }
    }

    previous() {
        //el.preventDefault()
        let curStep = this.getCurrentStep()
        this.showStep(curStep - 1)
    }
}

// Instantiation based on the HTML element with the `data-modal-trigger` attribute
document.querySelectorAll('[simple-wizard]').forEach(triggerElement => {
    new SimpleWizard(triggerElement as HTMLElement);
});